import React, { useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import {
  combineValidators,
  isRequired,
  composeValidators,
  hasLengthBetween,
} from "revalidate";
import { connect } from "react-redux";
import { FORM_ERROR } from "final-form";
import { Form, Header, Button, Container, Grid } from "semantic-ui-react";
import PropTypes from "prop-types";
import { login } from "../../app/store/actions/authActions";
import TextInput from "../../app/common/form/TextInput";
import ErrorMessage from "../../app/common/form/ErrorMessage";
import SelectedInput from "../../app/common/form/SelectedInput";
import { tipoDocumentoOptions } from "../../app/config/data/options";
import { Link } from "react-router-dom";
import {
  normalizeNumeroDocumentoIdentidad,
  getLengthNumeroDocumentoIdentidad,
  normalizePassword,
} from "../../app/util/finalFormUtils";
import {
  CODIGO_TIPO_DOCUMENTO_DNI,
  LONGITUD_TIPO_DOCUMENTO_DNI,
  LONGITUD_MAXIMA_PASSWORD,
} from "../../app/infrastructure/appConstants";
import PasswordField from "../../app/common/form/PasswordField";
//import createDecorator from "final-form-calculate";

const actions = {
  login,
};

/*const decorator = createDecorator({
  field: "tipoDocumento",
  updates: {
    numeroDocumento: (tipoDocumentoValue, allValues) => undefined,
  },
});*/

const LoginPage = ({ login }) => {
  const [tipoDocumentoCliente, setTipoDocumentoCliente] = useState(
    CODIGO_TIPO_DOCUMENTO_DNI
  );
  const [
    lengthNumeroDocumentoCliente,
    setLengthNumeroDocumentoCliente,
  ] = useState(LONGITUD_TIPO_DOCUMENTO_DNI);

  const onChangeTipoDocumentoCliente = (value) => {
    setTipoDocumentoCliente(value);
    //Actualizando longitud
    setLengthNumeroDocumentoCliente(getLengthNumeroDocumentoIdentidad(value));
  };

  const validate = combineValidators({
    tipoDocumento: composeValidators(
      isRequired({ message: "Tipo de documento es requerido" })
    )(),
    numeroDocumento: composeValidators(
      isRequired({ message: "Número de documento es requerido" }),
      hasLengthBetween(
        lengthNumeroDocumentoCliente,
        lengthNumeroDocumentoCliente
      )({
        message: "Número de documento no válido",
      })
    )(),
    password: composeValidators(
      isRequired({ message: "Contraseña es requerido" })
    )(),
  });

  return (
    <Container className="containerFormLogin">
      <FinalForm
        onSubmit={(values) =>
          login(values).catch((error) => ({ [FORM_ERROR]: error }))
        }
        validate={validate}
        initialValues={{
          tipoDocumento: tipoDocumentoCliente,
        }}
        //decorators={[decorator]}
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
        }) => (
          <Form onSubmit={handleSubmit} error>
            <br />
            <Header
              as="h1"
              content="Iniciar sesión"
              color="blue"
              textAlign="center"
            />
            <Field
              name="tipoDocumento"
              component={SelectedInput}
              placeholder="Tipo de documento"
              options={tipoDocumentoOptions}
              handleOnChange={onChangeTipoDocumentoCliente}
            />
            <Field
              name="numeroDocumento"
              component={TextInput}
              placeholder="Número de documento"
              parse={(value) =>
                normalizeNumeroDocumentoIdentidad(value, tipoDocumentoCliente)
              }
              maxLength={lengthNumeroDocumentoCliente}
            />

            <PasswordField
              name="password"
              placeholder="Contraseña"
              maxLength={LONGITUD_MAXIMA_PASSWORD}
              showPasswordStrengthMeter={false}
              extraValidation={false}
            />

            <br />

            <Grid divided="vertically">
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Button
                    fluid
                    size="large"
                    color="blue"
                    content="Cancelar"
                    as={Link}
                    to="/"
                  />
                </Grid.Column>
                <Grid.Column>
                  <Button
                    fluid
                    disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                    size="large"
                    loading={submitting}
                    color="yellow"
                    content="Ingresar"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>

            <Button
              as={Link}
              to="/recover"
              fluid
              basic
              color="blue"
              size="mini"
              content="¿Olvidaste tu contraseña?"
            />
          </Form>
        )}
      />
    </Container>
  );
};

LoginPage.propTypes = {
  login: PropTypes.func.isRequired,
};

export default connect(null, actions)(LoginPage);
